import {Component, inject, Input, OnInit, ViewChild} from '@angular/core';
import {Button} from 'primeng/button';
import {Divider} from 'primeng/divider';
import {GenericListComponent} from '../../../../../../components/generic/generic-list/generic-list.component';
import {InfoTextComponent} from '../../../../../shared/common/info-text/info-text.component';
import {LoadingComponent} from '../../../../../../components/generic/loading/loading.component';
import {MessageComponent} from '../../../../../../components/generic/message/message.component';
import {ConfirmationService, PrimeTemplate} from 'primeng/api';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {PlayerProfile} from '../../../../model/player-profile';
import {DialogService} from 'primeng/dynamicdialog';
import {RestErrorHelper} from '../../../../../../helper/rest-error-helper';
import {PlayerProfileService} from '../../../../service/player-profile.service';
import {ErrorType} from '../../../../../../model/error-type';
import {ColumnType} from '../../../../../../components/generic/generic-list/columnType';
import {PlayerProfileEvent} from '../../../../model/player-profile-event';
import {
  PlayerProfileAddLeagueDialogComponent
} from './player-profile-add-league-dialog/player-profile-add-league-dialog.component';
import {NgTemplateOutlet} from '@angular/common';
import {FrontendService} from '../../../../../../services/frontend.service';

@Component({
  selector: 'app-player-profile-my-leagues',
  imports: [
    Button,
    Divider,
    GenericListComponent,
    InfoTextComponent,
    LoadingComponent,
    MessageComponent,
    PrimeTemplate,
    TranslatePipe,
    NgTemplateOutlet
  ],
  templateUrl: './player-profile-my-leagues.component.html',
  styleUrl: './player-profile-my-leagues.component.scss'
})
export class PlayerProfileMyLeaguesComponent implements OnInit
{
  private translate = inject(TranslateService);
  private dialogService = inject(DialogService);
  private restErrorHelper = inject(RestErrorHelper);
  private playerProfileService = inject(PlayerProfileService);
  private confirmationService = inject(ConfirmationService);

  @ViewChild('calendarSyncTemplate') calendarSyncTemplate: any;
  @ViewChild('leagueLinkTemplate') leagueLinkTemplate: any;

  isLoading: boolean;
  listLoading: boolean;
  errorMsg: ErrorType;
  columns: any[];
  columnsMobile: ColumnType[];

  playerProfile: PlayerProfile;
  leagues: PlayerProfileEvent[];

  ngOnInit(): void
  {
    this.loadData();
  }

  private initColumns(): void
  {
    this.columns = [
      { header: 'LINK', headerIcon: 'pi pi-link', datatype: 'template', width: '40', template: this.leagueLinkTemplate },
      { header: 'SEASON', field: 'event.seasonName', datatype: '', width: '120', filterType: 'text', sortable: true, class: 'text-center' },
      { header: 'LEAGUE', field: 'event.name', datatype: '', width: '', filterType: 'text', sortable: true },
      { header: 'TEAM', field: 'participantName', datatype: '', width: '200', filterType: 'text', sortable: true, class: 'text-center' },
      { header: 'SYNCHRONIZE', headerIcon: 'pi pi-sync', datatype: 'template', width: '40', template: this.calendarSyncTemplate }
      // { header: 'SYNCHRONIZE', field: 'calendarSync', datatype: '', width: '170', filterType: 'text', sortable: true, class: 'text-center' },
    ];

    this.columnsMobile = [
      {
        key: 'MAT',
        header: 'LEAGUES'
      }
    ];
  }

  private loadData(): void
  {
    this.isLoading = true;
    this.playerProfileService.getLinkedLeagues().subscribe({
      next: data =>
      {
        console.log('Meine Ligen erhalten', data);
        this.initColumns();  // Wegen Templates später laden
        this.leagues = data;
        this.isLoading = false;
      },
      error: error =>
      {
        console.log('error', error);
        this.isLoading = false;
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  public linkLeague(): void
  {
    const ref = PlayerProfileAddLeagueDialogComponent.openDialog(this.dialogService,
      this.playerProfile, this.translate);
    ref.onClose.subscribe((result: boolean) =>
    {
      console.log('result: ', result);
      if (result)
        this.loadData();
    });
  }

  public removeLeague(item: PlayerProfileEvent): void
  {
    console.log('removeLeague: ', item);

    this.confirmationService.confirm({
      message: this.translate.instant('MSG_REMOVE_ITEM', {value: item.event.name}),
      header: this.translate.instant('MSG_HEADER_DELETE_ENTRY'),
      icon: 'pi pi-question-circle',
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      rejectButtonStyleClass: 'button-no button-right',
      accept: () =>
      {
        this.listLoading = true;
        this.playerProfileService.removePlayerLeague(item.id).subscribe({
          next: data =>
          {
            console.log('Liga entfernt', data);
            this.listLoading = false;
            this.loadData();
          },
          error: error =>
          {
            this.listLoading = false;
            this.restErrorHelper.handleErrorService(error);
          }
        });
      }
    });
  }

  public calendarSyncClicked(item: PlayerProfileEvent): void
  {
    const msg = item.calendarSync ? 'PLAYER_PROFILE_SYNC_LEAGUE_REMOVE_MSG' :
      'PLAYER_PROFILE_SYNC_LEAGUE_MSG';

    this.confirmationService.confirm({
      message: this.translate.instant(msg),
      header: this.translate.instant('SYNCHRONIZE_WITH_YOUR_CALENDAR'),
      icon: 'pi pi-question-circle',
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      rejectButtonStyleClass: 'button-no button-right',
      accept: () =>
      {
        this.listLoading = true;
        this.playerProfileService.activateOrDeactivateTeamLeagueCalendarSync(item.id, !item.calendarSync).subscribe({
          next: data =>
          {
            console.log('Sync aktiviert/deaktiviert', data);
            this.listLoading = false;
            item.calendarSync = !item.calendarSync;
          },
          error: error =>
          {
            this.listLoading = false;
            this.restErrorHelper.handleErrorService(error);
          }
        });
      }
    });
  }

  public openLeague(item: PlayerProfileEvent): void
  {
    if (item.event)
    {
      const url = FrontendService.getFrontendEventUriComplete(item.event.eventId, item.event.database);
      window.open(url, '_blank');
    }
  }
}
